import { Product } from '../types';
import appConfig from '../config/app.config';

const productImagesBucket: string = appConfig.AWS_S3_PRODUCT_IMAGES_BUCKET_NAME;

export function buildProductDefaultImageUrl(product: Product): string {
  return `https://s3.us-west-2.amazonaws.com/${productImagesBucket}/productimages/${product.productName}.jpg`;
}

export function buildProductMainImageUrl(product: Product): string {
  return product.mainImage
    ? `https://s3.us-west-2.amazonaws.com/${productImagesBucket}/productimages/${product.mainImage}.jpg`
    : '';
}

export function getProductImageUrl(product: Product): string {
  return buildProductMainImageUrl(product) || buildProductDefaultImageUrl(product);
}

export async function isProductImageExists(imageUrl: string): Promise<boolean> {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = imageUrl;
  });
}
